import { render, staticRenderFns } from "./DeliveryModal.vue?vue&type=template&id=b1d625cc&scoped=true&lang=pug"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryModal.vue?vue&type=style&index=0&id=b1d625cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d625cc",
  null
  
)

export default component.exports